import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Card, Button } from 'antd';

@inject('store')
@observer
export class LogsView extends Component {
    constructor(props) {
        super(props);
        this.state = { loading: false };
    }
    componentDidMount() {
        this.props.store.odysseyBotStore.getLogs(this.props.match.params.id);

        let timeleft = 30;
        this.interval = setInterval(async () => {
            this.setState({ timeleft });
            timeleft -= 1;
            if (timeleft <= 0) {
                this.setState({ loading: true });
                await this.props.store.odysseyBotStore.getLogs(this.props.match.params.id);
                this.setState({ loading: false });
                timeleft = 30;
            }
        }, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        return (
            <Card
                title={'Logs'}
                bordered={false}
                extra={
                    <Button disabled loading={this.state.loading} type="primary">
                        {this.state.timeleft || 0} Refresh
                    </Button>
                }
            >
                {this.props.store.odysseyBotStore.logs.map((logRow, i) => {
                    return <div key={i}>{logRow}</div>;
                })}
            </Card>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/LogsView/index.js